document.querySelectorAll('.filters').forEach((filters) => {
  const toggleable = filters.querySelector('.filters__toggleable');

  filters.querySelectorAll('.filters__toggle, .filters__show-results-button').forEach((toggle) =>
    toggle.addEventListener('click', () => {
      toggleable.classList.toggle('filters__toggleable--visible');
      toggleable.classList.toggle('has-light-background');
      document.body.classList.toggle('is-mobile-filter-visible');
    })
  );
});